import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { Button, Buttons, MessageType } from 'src/app/common/messagePopupModel';
import { MessageAlertPopupComponent } from './message-alert-popup.component';

@Injectable({
  providedIn: 'root'
})
export class MessagePopupService {

  constructor(private dialog: MatDialog) { }

  private dialogResultSubject!: Subject<Button>;
  dialogResult$!: Observable<Button>;

  show(type: MessageType, title?: string, message?: string, buttons?: Buttons): MessagePopupService {
    let dialogRef = this.dialog.open(MessageAlertPopupComponent, {
      data: {
        type: type ?? MessageType.Info,
        message,
        title,
        buttons: buttons ??  Buttons.Okay
      }
    });

    this.dialogResultSubject = new Subject<Button>();
    this.dialogResult$ = this.dialogResultSubject.asObservable();
    
    dialogRef.componentInstance.dialogResult$.subscribe(pressedButton => {
      this.dialogResultSubject.next(pressedButton);
      this.dialogResultSubject.complete();
      dialogRef.close();
    });

    return this;
  }
}